export const DEACTIVATED = 'deactivated';
export const DOCUMENT = 'document';
export const REACTIVATED = 'reactivated';
export const RETRY = 'retry';
export const SUSPENDED = 'suspended';
export const UNVERIFIED = 'unverified';
export const VERIFIED = 'verified';
export const DOCUMENT_SENT = 'document_sent';
export const RETRY_SENT = 'retry_sent';
